import Api from '@/services/Api';
import Parametrizacao from '@/model/Parametrizacao';

const RECURSO = '/parametrizacoes';
const RECURSO_LOCALIZACAO = '/localizacoes';
const RECURSO_ROTAS = '/rotas';
export default {
    newParametrizacao,
    getParametrizacao,
    getAllParametrizacao,
    postParametrizacao,
    postParametrizacaoRetornar,
    putParametrizacao,
    deleteParametrizacao,
    getLocalizacaoPadrao,
    putLocalizacao,
    getRotasPadrao,
    putRotas
};

function newParametrizacao(id=0, internacionalizacao={}, dadosInformativos={}){
    return new Parametrizacao(id,nome,sigla);
}

function getParametrizacao (id) {
    return Api.get(`${RECURSO}/${id}`);
}

function getLocalizacaoPadrao () {
    return Api.get(`${RECURSO}${RECURSO_LOCALIZACAO}/padrao`);
}

function putLocalizacao(payload){
    return Api.put(`${RECURSO}${RECURSO_LOCALIZACAO}/${payload.id}`, payload);
}

function getAllParametrizacao(){
    return Api.get(`${RECURSO}`)
}

function postParametrizacao(payload){
    return Api.post(`${RECURSO}`, payload);
}

function postParametrizacaoRetornar(payload){
    return Api.post(`${RECURSO}/retornar`, payload);
}

function putParametrizacao(payload){
    return Api.put(`${RECURSO}/${payload.id}`, payload);
}

function deleteParametrizacao(id){
    return Api.delete(`${RECURSO}/${id}`);
}

function getRotasPadrao () {
    return Api.get(`${RECURSO}${RECURSO_ROTAS}/padrao`);
}

function putRotas(payload){
    return Api.put(`${RECURSO}${RECURSO_ROTAS}/${payload.id}`, payload);
}
